export default __webpack_public_path__ + "static/media/castercam_frame.d501a1ef.png";